import {
  itemHasContent,
  countCollectionItemsIsFilled,
} from '../../utils/helpers';

const VP_FIELDS = ['product', 'reason'];
const COMPETITOR_FIELDS = ['name', 'doWell', 'doBadly'];
const USP_FIELDS = ['description'];

export default function calculateVPProgress(rootState, minRequired = 1) {
  let filledCount = 0;
  let totalCollectionItems = 0;

  VP_FIELDS.forEach((field) => {
    if (itemHasContent(rootState.valueProposition, [field])) filledCount += 1;
    totalCollectionItems += 1;
  });

  filledCount += countCollectionItemsIsFilled(
    rootState.competitor.collection,
    COMPETITOR_FIELDS,
  );
  totalCollectionItems += rootState.competitor.collection.length;

  filledCount += countCollectionItemsIsFilled(
    rootState.uniqueSellingPoint.collection,
    USP_FIELDS,
  );
  totalCollectionItems += rootState.uniqueSellingPoint.collection.length;

  if (filledCount === 0) return 0;
  const denominator = Math.max(minRequired, totalCollectionItems);
  const sectionProgress = Math.round((filledCount / denominator) * 100);
  return sectionProgress;
}
